import { create } from 'zustand';
import { createDefaultFilterSlice, DefaultFilterState } from '../defaultFilterSlice';
import { persist } from 'zustand/middleware';

export const useQualificationsListFilterStore = create<DefaultFilterState>()(
  persist(
    (...a) => ({
      ...createDefaultFilterSlice(...a),
    }),
    {
      name: 'qualificationsList',
    },
  ),
);
